//
// Copyright 2020 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/error.proto (package dxos.error, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/error.proto.
 */
export const file_dxos_error: GenFile = /*@__PURE__*/
  fileDesc("ChBkeG9zL2Vycm9yLnByb3RvEgpkeG9zLmVycm9yIp4BCgVFcnJvchIRCgRuYW1lGAEgASgJSACIAQESFAoHbWVzc2FnZRgCIAEoCUgBiAEBEi0KB2NvbnRleHQYBCABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0SAKIAQESEgoFc3RhY2sYAyABKAlIA4gBAUIHCgVfbmFtZUIKCghfbWVzc2FnZUIKCghfY29udGV4dEIICgZfc3RhY2tCK1opZ2l0aHViLmNvbS9keG9zL2R4b3MvcHJvdG8vZGVmL2R4b3MvZXJyb3JiBnByb3RvMw", [file_google_protobuf_struct]);

/**
 * / Serialized error.
 *
 * @generated from message dxos.error.Error
 */
export type Error = Message<"dxos.error.Error"> & {
  /**
   * / Also error code. Will be used to reconstruct a known error type.
   *
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * @generated from field: optional string message = 2;
   */
  message?: string;

  /**
   * @generated from field: optional google.protobuf.Struct context = 4;
   */
  context?: JsonObject;

  /**
   * @generated from field: optional string stack = 3;
   */
  stack?: string;
};

/**
 * Describes the message dxos.error.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema: GenMessage<Error> = /*@__PURE__*/
  messageDesc(file_dxos_error, 0);

